import { render } from "./audioPlayer3.vue?vue&type=template&id=333ac37e&scoped=true"
import script from "./audioPlayer3.vue?vue&type=script&lang=js"
export * from "./audioPlayer3.vue?vue&type=script&lang=js"

import "./audioPlayer3.vue?vue&type=style&index=0&id=333ac37e&lang=scss&scoped=true"
import "./audioPlayer3.vue?vue&type=style&index=1&id=333ac37e&lang=scss"
script.render = render
script.__scopeId = "data-v-333ac37e"

export default script